module.exports = __webpack_public_path__ + "img/jiuzhang-back-phone@3x.967350c8.png";